<template>
    <section id="ahs-new-request" class="pt-3 page-container px-0">
        <component :is="conditionalComponent" mode="new" @onSave="onSave" @cancelCreation="onCancel" class="mt-3" />
    </section>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import translate from '@/utils/translate.util';

import EntityRequestComponent from '@/components/ahs-requests/EntityRequestComponent';
import KSKRequestComponent from '@/components/ahs-requests/KSKRequestComponent';

export default {
    components: { EntityRequestComponent, KSKRequestComponent },
    computed: {
        ...mapState({
            requestTypes: function(state) {
                return translate(state.ahsRequests.requestTypes, 'full', this.$i18n.locale);
            },
            userData: function(state) {
                return translate(state.users?.userInfo?.user_data, 'full', this.$i18n.locale);
            }
        }),
        conditionalComponent() {
            return this.userData?.isas_contract_rid ? 'EntityRequestComponent' : 'KSKRequestComponent';
        }
    },
    methods: {
        ...mapActions('documents', ['getUserContractsList']),
        ...mapActions('ahsRequests', ['createAHSRequest']),

        async onSave(payload) {
            const createdRequest = await this.createAHSRequest(payload);
            const message = this.$t('Заявка создана');
            this.$store.dispatch('base/showMessage', { color: 'success', message });

            this.$router.replace({ name: 'AHSRequestDetails', params: { id: createdRequest.record_id } });
        },

        onCancel() {
            this.$router.replace({ name: 'AHSRequests' });
        }
    },
    created() {
        this.getUserContractsList({ ContractRid: this.userData?.isas_contract_rid });
    }
};
</script>

<style></style>
